import { createSelector } from 'reselect';

// reselect function
export const getWrapState = createSelector(
    [],
    () => (
        {}
    )
);
